/*
 * @Author: Alan
 * @Date: 2023-04-18 09:15:24
 * @LastEditors: Alan
 * @LastEditTime: 2023-06-17 15:52:01
 * @Description: 第三步
 * @FilePath: /F1-M1-WEB-Code/components/Wallet/withdrawComponents/FinishStep/index.js
 */
import React from "react";
import { Button, Steps } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { sendPiwikEvent } from "$ACTIONS/PiwikUtil";
import { CommonPostPay } from "$DATA/wallet";
const { Step } = Steps;

class FinishStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {}
    copyEvent() {
        global.showColorResultModal("已复制", true);
    }
    handleTime(time) {
        if (time == 0) {
            return `您的提款将于1小时内完成， 请您耐心等待！`;
        } else if (time / 60 >= 1) {
            if (time % 60 == 0) {
                return `您的提款将于${time / 60}小时内完成， 请您耐心等待！`;
            } else {
                return `您的提款将于${parseInt(time / 60)}小时${
                    time % 60
                }分钟内完成， 请您耐心等待！`;
            }
        } else {
            return `您的提款将于${time % 60}分钟内完成， 请您耐心等待！`;
        }
    }
    render() {
        let {
            Time,
            collectionInfo,
            goRecord,
            WithdrawKey,
            rebateAmount,
            payoutMode,
            goHome,
        } = this.props; // 当前支付方式的详情

        console.log("-------------->", collectionInfo);
        return (
            <div className="lb-third-step-wrap">
                <div className="stepDone">
                    <img
                        src="/cn/img/icons/icon-success.png"
                        width={"60px"}
                        className="iconstatus"
                    />
                    <div className="successtext">已成功提交</div>
                    <div className="StepsBox depositSuccess">
                        <Steps current={0} direction="vertical" size="small">
                            <Step
                                className="firstStep"
                                title="提交成功"
                                description="处理中"
                                icon={
                                    <BsCheckCircleFill
                                        color="#00A5FD"
                                        size={17}
                                    />
                                }
                            />
                            <Step
                                className="lastStep"
                                title=""
                                description={`${this.handleTime(
                                    collectionInfo.withdrawalTime
                                )}`}
                                icon={<BsCircle color="#999999" size={13} />}
                            />
                        </Steps>
                    </div>
                    <div className="DepositInfo">
                        <div className="list">
                            <span>提款金额</span>
                            <span className="bold">
                                ¥{" "}
                                {collectionInfo && collectionInfo.uniqueAmount}
                            </span>
                        </div>
                        <div className="list">
                            <span>交易单号</span>
                            <span>
                                {collectionInfo && collectionInfo.transactionId}
                                <CopyToClipboard
                                    text={
                                        collectionInfo &&
                                        collectionInfo.transactionId
                                    }
                                    onCopy={this.copyEvent}
                                >
                                    <img
                                        style={{
                                            marginLeft: "0.4rem",
                                            cursor: "pointer",
                                        }}
                                        src={`/cn/img/icons/Copys.svg`}
                                    />
                                </CopyToClipboard>
                            </span>
                        </div>
                    </div>
                    {collectionInfo.payoutMode === "SmallRiver" && (
                        <div
                            className="modal-prompt-info"
                            style={{ textAlign: "left", margin:'16px 16px 2px',padding:0 }}
                        >
                            <div className="DONENOTE">
                                {collectionInfo.rebateAmount != undefined &&
                                    collectionInfo.rebateAmount != 0 && (
                                        <h3>
                                            恭喜您！您在此笔提款交易中将获得额外红利，若您收到该笔交易金额后，可在交易记录页面中查看额外红利并点击“确认到账”领取额外红利。
                                        </h3>
                                    )}
                                {(!collectionInfo.rebateAmount ||
                                    collectionInfo.rebateAmount == 0) && (
                                    <h3>
                                        若银行账户已收到该款项，请前往交易记录页面点击”确认到账“。
                                    </h3>
                                )}
                                <ul><li>
                                请注意，本站不会在金额还没到账前通知会员点击“确认到账”。
                                <span className="red">请留意您的资金安全</span>
                                。 </li>
                                <li>
                                若您在尚未检查的情况下点击“确认到账”，所产生的损失本站
                                <span className="red">概不负责赔偿</span>。</li>
                                <li>请确认您的金额是否已到账。</li></ul>
                            </div>
                        </div>
                    )}
                </div>
                <center>
                    {collectionInfo.WithdrawKey !== "LB" && (
                        <p className="note">请注意。交易将以实时汇率进行 </p>
                    )}
                </center>
                <br></br>
                <div className="btn-wrap">
                    <Button
                        size="large"
                        type="primary"
                        htmlType="submit"
                        onClick={() => {
                            goRecord();
                            let PaymentMethod = this.props.successBy;
                            sendPiwikEvent('Withdrawal Submit',
                                `Withdrawal Submit ${PaymentMethod} Check Record`,
                                `WithdrawalSubmit_${PaymentMethod}_C_CheckRecord`);
                        }}
                        block
                    >
                        查看交易记录
                    </Button>

                    <Button
                        ghost
                        size="large"
                        type="primary"
                        htmlType="submit"
                        onClick={() => {
                            goHome();
                        }}
                        block
                        style={{ marginTop: "15px" }}
                    >
                        回到首页
                    </Button>
                </div>
            </div>
        );
    }
}
export default FinishStep;
